import React from 'react'
import ReactLoading from 'react-loading'
import classnames from 'classnames'

import './loader.css'

const Loader = (props) => {
  // options: https://www.npmjs.com/package/react-loading
  const type = 'bubbles'
  const color = 'currentcolor'

  return (
    <div className={classnames({
      'loader': true,
      'loader--show': props.show
    })}>
      <ReactLoading
        type={type}
        color={color}
        height={75}
        width={75}
      />
    </div>
  )
}

export default Loader



// WEBPACK FOOTER //
// ./src/components/Loader/index.js